<template>
  <div>
    <h1 class="headline">{{ $t('pages.dashboard.title.default') }}</h1>
    <v-card v-for="offer in offers" :key="offer" class="transparent" flat>
      <v-card-title>{{ $t(`pages.dashboard.title.${offer}`) }}</v-card-title>
      <v-card-text>
        <v-layout row wrap>
          <v-flex xs12 md6 v-for="scope in scopes" :key="scope">
            <v-card class="mb-3">
              <v-card-title>
                <h4 class="subheading ma-0">{{ $t(`pages.dashboard.title.${scope}`) }}</h4>
                <v-spacer></v-spacer>
                <v-btn icon flat @click.native.stop="refresh(offer, scope)">
                  <v-icon>autorenew</v-icon>
                </v-btn>
              </v-card-title>
              <purchase-table
                compact
                :serviceType="offer"
                :adminId="adminFilter"
                :scope="scope"
                @filterUpdated="filter => updateFilter(offer, scope, filter)">
              </purchase-table>
            </v-card>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import Expert from '@/api/currentExpert'
  import { PurchaseTable } from '@/components/purchase'
  export default {
    components: {
      PurchaseTable
    },
    props: {
      offers: {
        type: Array,
        default: () => [
          'phone',
          'availability',
          'mail',
          'service'
        ]
      },
      scopes: {
        type: Array,
        default: () => [
          'pending',
          'current'
        ]
      }
    },
    data () {
      return {
        filters: {}
      }
    },
    computed: {
      ...mapGetters({
        currentExpert: 'skiliko/session/currentUser'
      }),
      adminFilter () {
        return Expert.isAdmin(this.currentExpert) ? null : this.currentExpert.id
      }
    },
    methods: {
      ...mapActions({
        fetchPage: `skiliko/purchases/fetchPerPage`
      }),
      updateFilter (offer, scope, filter) {
        this.filters[offer] = this.filters[offer] || {}
        this.filters[offer][scope] = filter
      },
      refresh (offer, scope) {
        this.fetchPage((this.filters[offer] || {})[scope])
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/Dashboard.vue